module.exports = __webpack_public_path__ + "static/media/12 Personal My Room 001_360.c0db659d.jpeg";